import { gsap } from "gsap";

export class VideoPlayer {
            constructor(onVideoEndCallback = null) {
    this.videoOverlay = document.getElementById('video-overlay');
    this.video = document.getElementById('intro-video');
    this.loadingBar = document.getElementById('loading-bar');
    this.progressBar = document.getElementById('progress-bar');
    this.skipButton = document.getElementById('skip-video-btn');
    this.isFirstVisit = this.checkFirstVisit();
    this.body = document.querySelector('body');
    this.header = document.querySelector('.header');
    this.main = document.querySelector('.main');
    this.simbaLogoWrap = document.querySelector(".simba-logo-wrap");
    this.onVideoEndCallback = onVideoEndCallback;

    if (this.isFirstVisit) {
      this.init();
    } else {
      this.hideOverlay();
      // 初回訪問でない場合は即座にコールバックを実行
      if (this.onVideoEndCallback) {
        this.onVideoEndCallback();
      }
    }

    // リサイズイベントリスナーを追加
    this.setupResizeListener();
  }

  checkFirstVisit() {
    const hasVisited = sessionStorage.getItem('simba-video-played');
    if (!hasVisited) {
      sessionStorage.setItem('simba-video-played', 'true');
      return true;
    }
    return false;
  }

  init() {
    if (!this.videoOverlay || !this.video || !this.loadingBar || !this.progressBar) {
      this.hideOverlay();
      return;
    }

    // デバイスの画面サイズに基づいてビデオソースを選択
    this.selectVideoSource();

    this.setupVideoEvents();
    this.setupSkipButton();
    this.video.load();
    // 動画の読み込みを少し遅延させる
    setTimeout(() => {
      this.video.classList.remove("hidden");
      this.playVideo();
    }, 500);
  }

  selectVideoSource() {
    const isMobile = window.innerWidth <= 768;

    // WebM対応確認
    const canPlayWebM = () => {
      const video = document.createElement('video');
      return video.canPlayType('video/webm; codecs="av01.0.08M.08"') !== '';
    };

    // 既存のソースをクリア
    this.video.innerHTML = '';

    if (isMobile) {
      // スマホの場合
      if (canPlayWebM()) {
        // WebM対応の場合、スマホ用WebMを最初に追加
        const mobileWebMSource = document.createElement('source');
        mobileWebMSource.src = './assets/video/SHIMBA_1920x1080_fhd_0730-sp.webm';
        mobileWebMSource.type = 'video/webm';
        this.video.appendChild(mobileWebMSource);

        // フォールバック用のスマホ用MP4
        const mobileMP4Source = document.createElement('source');
        mobileMP4Source.src = './assets/video/SHIMBA_1920x1080_fhd_0730-sp.mp4';
        mobileMP4Source.type = 'video/mp4';
        this.video.appendChild(mobileMP4Source);
      } else {
        // WebM非対応の場合、スマホ用MP4を最初に追加
        const mobileSource = document.createElement('source');
        mobileSource.src = './assets/video/SHIMBA_1920x1080_fhd_0730-sp.mp4';
        mobileSource.type = 'video/mp4';
        this.video.appendChild(mobileSource);
      }

      // 最終フォールバック用のPC用MP4
      const fallbackSource = document.createElement('source');
      fallbackSource.src = './assets/video/SHIMBA_1920x1080_fhd_0730.mp4';
      fallbackSource.type = 'video/mp4';
      this.video.appendChild(fallbackSource);
    } else {
      // PCの場合
      if (canPlayWebM()) {
        // WebM対応の場合、PC用WebMを最初に追加
        const pcWebMSource = document.createElement('source');
        pcWebMSource.src = './assets/video/SHIMBA_1920x1080_fhd_0730.webm';
        pcWebMSource.type = 'video/webm';
        this.video.appendChild(pcWebMSource);
      }

      // PC用MP4を追加
      const pcMP4Source = document.createElement('source');
      pcMP4Source.src = './assets/video/SHIMBA_1920x1080_fhd_0730.mp4';
      pcMP4Source.type = 'video/mp4';
      this.video.appendChild(pcMP4Source);
    }
  }

  setupResizeListener() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // ビデオがまだ再生されていない場合のみソースを変更
        if (this.video && this.video.paused) {
          this.selectVideoSource();
          this.video.load();
        }
      }, 250);
    });
  }



  setupVideoEvents() {
    this.video.addEventListener('loadedmetadata', () => {
      this.updateProgress();
    });

    this.video.addEventListener('ended', () => {
      this.onVideoEnd();
    });

    this.video.addEventListener('error', (e) => {
      this.hideOverlay();
    });

    this.video.addEventListener('loadstart', () => {
      this.updateProgress();
    });

    this.video.addEventListener('canplay', () => {
      this.updateProgress();
    });

    this.video.addEventListener('progress', () => {
      this.updateProgress();
    });

    this.video.addEventListener('loadeddata', () => {
      this.updateProgress();
    });

    this.video.addEventListener('canplaythrough', () => {
      this.updateProgress();
    });
  }

  setupSkipButton() {
    if (this.skipButton) {
      this.skipButton.addEventListener('click', () => {
        this.skipVideo();
      });
    }
  }

  skipVideo() {
    // セッションストレージを更新して動画をスキップ済みとしてマーク
    sessionStorage.setItem('simba-video-played', 'true');

    // 動画を終了
    this.onVideoEnd();
  }

  playVideo() {
    // 1秒の遅延を追加
    setTimeout(() => {
      // 動画が既に読み込まれている場合は直接再生
      if (this.video.readyState >= 2) {
        this.hideLoadingBar();
        this.video.play().then(() => {
          // Video play started successfully
        }).catch((error) => {
          this.hideOverlay();
        });
      } else {
        // 動画がまだ読み込まれていない場合は、読み込み完了を待つ
        this.video.addEventListener('canplay', () => {
          this.hideLoadingBar();
          this.video.play().then(() => {
            // Video play started successfully
          }).catch((error) => {
            this.hideOverlay();
          });
        }, { once: true });
      }
    }, 1000); // 1秒の遅延
  }

  hideLoadingBar() {
    if (this.loadingBar) {
      // フェードアウトアニメーションを追加
      gsap.to(this.loadingBar, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
        onComplete: () => {
          this.loadingBar.classList.add('hidden');
        }
      });
    }
  }

    updateProgress() {
    if (this.video && this.progressBar) {
      let progress = 0;

      // 動画の読み込み状態に基づいて進捗を計算
      if (this.video.readyState >= 4) {
        // 動画が完全に読み込まれている
        progress = 100;
      } else if (this.video.readyState >= 3) {
        // 動画のメタデータと一部のデータが読み込まれている
        progress = 75;
      } else if (this.video.readyState >= 2) {
        // 動画のメタデータが読み込まれている
        progress = 50;
      } else if (this.video.readyState >= 1) {
        // 動画の読み込みが開始されている
        progress = 25;
      } else {
        // 動画の読み込みが開始されていない
        progress = 0;
      }

      // バッファリング情報も考慮
      if (this.video.buffered.length > 0 && this.video.duration) {
        const bufferedEnd = this.video.buffered.end(this.video.buffered.length - 1);
        const bufferedProgress = (bufferedEnd / this.video.duration) * 100;
        progress = Math.max(progress, bufferedProgress);
      }

      this.progressBar.style.width = progress + '%';

      // 進捗が100%になったらローディングバーを非表示にする準備
      if (progress >= 100) {
        setTimeout(() => {
          this.hideLoadingBar();
        }, 400); // 0.2秒後に非表示
      }
    }
  }

  onVideoEnd() {
    // GSAPでフェードアウトアニメーション
    gsap.to(this.videoOverlay, {
      opacity: 0,
      duration: 0.6,
      ease: "power2.inOut",
      onComplete: () => {
        this.hideOverlay();
        // 動画終了後にコールバックを実行
        if (this.onVideoEndCallback) {
          this.onVideoEndCallback();
        }
      }
    });
  }

  hideOverlay() {
    if (this.videoOverlay) {
      this.videoOverlay.classList.add('hidden');


      setTimeout(() => {
        this.body.classList.remove("hidden");
      }, 100);

      setTimeout(() => {
        this.header.classList.remove("hidden");
      }, 200);


      setTimeout(() => {
        this.main.classList.remove("hidden");
        this.body.classList.add("video-played");
      }, 300);


      setTimeout(() => {
        this.simbaLogoWrap.classList.remove("hidden");
      }, 800);





      // gsap.to(this.videoOverlay, {
      //   opacity: 0,
      //   duration: 1,
      //   ease: "power2.inOut",
      //   onComplete: () => {
      //     // this.hideOverlay();
      //     sessionStorage.setItem("simba-video-played", "false");
      //   },
      // });
    }
    if (this.video) {
      this.video.pause();
      // this.video.src = '';
    }
  }
}
